import { render, staticRenderFns } from "./EditMail.vue?vue&type=template&id=0d895a5f&scoped=true&"
import script from "./EditMail.vue?vue&type=script&lang=js&"
export * from "./EditMail.vue?vue&type=script&lang=js&"
import style0 from "./EditMail.vue?vue&type=style&index=0&id=0d895a5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d895a5f",
  null
  
)

export default component.exports